import {has} from '@malt/common';

const modules = {};

export const registry = {
    contains(name) {
        return has(modules, name);
    },

    store(name, moduleInstance) {
        modules[name] = moduleInstance;
    },

    get(name) {
        return modules[name];
    },
};
